// extracted by mini-css-extract-plugin
var _1 = "TradePricingStyle-module__max___f_nlI";
var _2 = "TradePricingStyle-module__trade-pricing___bcqMi";
var _3 = "TradePricingStyle-module__trade-pricing___bcqMi";
export { _1 as "max", _2 as "trade-pricing", _3 as "tradePricing" }
